"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DeviceParams;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _constants = require("../../constants");

require("./DeviceParams.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DeviceParams(props) {
  var xLabelPos;
  var yLabelPos;
  var TOP_VAL = parseInt(props.asset.top.substring(-2));
  var LEFT_VAL = parseInt(props.asset.left.substring(-2));

  if (props.asset.left && props.asset.top) {
    xLabelPos = LEFT_VAL + 50; // can be used for labels

    yLabelPos = TOP_VAL + 4; // can be used for labels

    if (props.asset.className === 'battery') {
      xLabelPos -= 25;
      yLabelPos += 75;
    }
  }

  if (props.asset.data.AlignLeft === true || props.asset.AlignLeft) {
    // left align table if marked
    xLabelPos = parseInt(props.asset.left.substring(-2)) - 150 / _constants.core.ROOT_SIZE;
  }

  var renderElement = function renderElement() {
    var liveDataOfAssetKeys = (0, _lodash.keys)(props.asset.data);
    var assetKeys = (0, _lodash.keys)(props.asset);
    var commonSelectedParams = (0, _lodash.intersection)(assetKeys, liveDataOfAssetKeys);
    var isAnySelectedParamMatches = commonSelectedParams.find(function (key) {
      return props.asset[key] === true;
    });
    if (!isAnySelectedParamMatches && props.isNoParamsSelectedTitleShow) return /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", null, /*#__PURE__*/_react.default.createElement("b", null, /*#__PURE__*/_react.default.createElement("i", null, "Please Select Data Points"))));else {
      var TxId = _constants.core.ASSET_PREFIX + props.asset.txId;
      return (0, _lodash.map)(commonSelectedParams, function (element, i) {
        return props.asset[element] && ((0, _lodash.includes)(['Asset', 'DateAndTime', 'AlignLeft', 'DoublePoint'], element) ? /*#__PURE__*/_react.default.createElement("tr", {
          key: "".concat(i, "_").concat(TxId)
        }, /*#__PURE__*/_react.default.createElement("td", {
          colSpan: "2"
        }, /*#__PURE__*/_react.default.createElement("b", null, props.asset.data[element]))) : /*#__PURE__*/_react.default.createElement("tr", {
          key: "".concat(i, "_").concat(TxId),
          style: {
            fontWeight: 'bold'
          }
        }, /*#__PURE__*/_react.default.createElement("td", {
          style: {
            display: 'inline-block',
            wordBreak: 'break-word'
          }
        }, element), /*#__PURE__*/_react.default.createElement("td", {
          style: {
            wordBreak: 'break-word'
          }
        }, props.asset.data[element])));
      });
    }
  };

  return /*#__PURE__*/_react.default.createElement("span", {
    className: "device-container",
    style: {
      left: "".concat(xLabelPos, "px"),
      top: "".concat(yLabelPos, "px"),
      width: "".concat(props.width * 2.9, "px")
    }
  }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("tbody", null, renderElement())));
}